<script>
	import { afterUpdate } from 'svelte';

	export let autocomplete = '';
	/** @type {number | null} */
	export let cols = null;

	export let disabled = false;

	export let id = '';

	export let automaticRows = false;

	/** @type {string | undefined} */
	export let inputmode = undefined;

	export let label = '';

	/** @type {null | number} */
	export let maxlength = null;

	/** @type {null | number} */
	export let minlength = null;

	/** @type {string | undefined} */
	export let name = undefined;

	/** @type {null | string} */
	export let placeholder = null;

	export let readonly = false;

	export let required = false;

	/** @type {number | undefined} */
	export let rows = 2;

	/** @type {'sm' | 'md' | 'lg' = } */
	export let size = 'md';

	/** @type {string | undefined} */
	export let value = undefined;

	export let spellcheck = false;

	export let wrap = 'soft';

	let textareaEl;

	$: tag = $$slots.label || label ? 'label' : 'div';

	$: id = id ? `id-${crypto.randomUUID()}` : crypto.randomUUID();

	function updateRows() {
		if (!automaticRows) return;

		if (!value || value.length === 0) {
			rows = 2;
			return;
		}

		const lineHeight = parseInt(getComputedStyle(textareaEl).lineHeight, 10);
		const scrollHeight = textareaEl.scrollHeight;

		let updatedRows = Math.floor(scrollHeight / lineHeight);

		rows = updatedRows >= 16 ? 16 : updatedRows > 2 ? updatedRows : 2;
	}

	afterUpdate(updateRows);
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
	this={tag}
	class="textarea {size}"
	class:active={value?.length}
	class:disabled
	class:readonly
	on:click
>
	{#if $$slots.label || label}
		<div class="label">
			<slot name="label">
				{label}
			</slot>
		</div>
	{/if}
	<div class="field">
		<textarea
			class:active={value?.length}
			{autocomplete}
			{cols}
			{disabled}
			{id}
			{inputmode}
			{minlength}
			{maxlength}
			{name}
			{placeholder}
			{required}
			{readonly}
			{rows}
			{spellcheck}
			{wrap}
			bind:value
			bind:this={textareaEl}
			on:input
			on:keydown
		/>
	</div>
</svelte:element>

<style>.textarea{--hsl-textarea-border:var(--hsl-gray-light);display:inline-grid;gap:.375rem}.textarea:not(.disabled):not(.readonly):hover{--hsl-textarea-border:var(--hsl-primary), 0.5}.textarea:not(.disabled):not(.readonly):focus-within{--hsl-textarea-border:var(--hsl-primary)}.textarea.active:not(.disabled):not(.readonly){--hsl-textarea-border:var(--hsl-primary)}.textarea.disabled,.textarea.disabled textarea,.textarea.readonly,.textarea.readonly textarea{cursor:not-allowed}.label,textarea{font:var(--f-ui-md-medium)}.label{color:hsla(var(--hsl-gray-extra-dark))}.field{display:inline-flex;background:hsla(var(--hsl-white));border:2px solid hsla(var(--hsl-textarea-border))}.sm .field{border-radius:.875rem;padding:.625rem}.md .field{padding:.75rem .625rem}.lg .field{padding:.875rem .75rem}.lg .field,.md .field{border-radius:1rem}textarea{background:0 0;outline:0;white-space:pre-wrap;width:100%}textarea:-moz-read-only:not([disabled]){color:hsla(var(--hsl-black),.75)!important}textarea:read-only:not([disabled]){color:hsla(var(--hsl-black),.75)!important}textarea::-moz-placeholder{overflow:hidden;text-overflow:ellipsis;white-space:none}textarea::placeholder{overflow:hidden;text-overflow:ellipsis;white-space:none}</style>
